import React, { Component, Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import autoBind from 'react-autobind';
import _ from 'lodash';
import DDadosItem from '@common/components/ddados/ddados.item';
import Panel from '@common/components/panel/panel.component';
import { EnumTipoCaracteristica } from '../enums/tipoCaracteristica.enum';

export default class CamposDinamicosCaracteristicas extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  /*
    Pai: Pannel representado por caracteristicas de nivel = 1
    Filha: DDadosItem representado por caracteristicas de nivel = 2

    O componente recebe um array de Pais. Cada pai tem uma prop chamada CaracteristicasFilhas que contem um array de Filhas.
  */

  callPropsChange(value) {
    const { onChange } = this.props;
    onChange && onChange(value);
  }

  /*
    Funcao que manipula o array de caracteristicas e retorna o mesmo array com a prop Valor preenchida no campo alterado
  */
  onChangeCaracteristica(indexPai, indexFilha, Valor) {
    const { state } = this.props;

    let arrayCaracteristicas = [...state];
    let novoObjetoPai = { ...arrayCaracteristicas[indexPai] };
    let novoObjetoFilha = { ...novoObjetoPai.CaracteristicasFilhas[indexFilha] };

    let novoValor;

    if (novoObjetoFilha.TipoCaracteristica == EnumTipoCaracteristica.Tabela) {
      novoValor = Valor;
    } else {
      novoValor = {
        Id: 0,
        IdCaracteristica: 0,
        Codigo: 0,
        Exibicao: Valor,
      };
    }

    let novoObjetoFilhaAlterado = { ...novoObjetoFilha, Valor: novoValor };

    let novasFilhas = [...novoObjetoPai.CaracteristicasFilhas];

    novasFilhas[indexFilha] = novoObjetoFilhaAlterado;
    novoObjetoPai.CaracteristicasFilhas = novasFilhas;
    arrayCaracteristicas[indexPai] = novoObjetoPai;
    this.callPropsChange(arrayCaracteristicas);
  }

  /*
    Funcao genérica de retorno de Pai (Pannel)
  */
  returnCaracteristicaPai(caracteristicaPai, indexPai) {
    return (
      <Row key={caracteristicaPai.Id}>
        {caracteristicaPai.CaracteristicasFilhas &&
          caracteristicaPai.CaracteristicasFilhas.map((caracteristicaFilha, indexFilha) => (
            <Col key={caracteristicaFilha.IdCaracteristica} lg={caracteristicaFilha.TamanhoTela}>
              {this.returnCaracteristicaFilha(caracteristicaFilha, indexFilha, indexPai)}
            </Col>
          ))}
      </Row>
    );
  }

  /*
    Funcao com estilização do sistema interno
  */
  returnCaracteristicaPaiInterno(caracteristicaPai, indexPai) {
    const { hidePaiPanel } = this.props;

    if (hidePaiPanel) return this.returnCaracteristicaPai(caracteristicaPai, indexPai);
    else
      return (
        <Panel title={caracteristicaPai.Descricao} key={caracteristicaPai.IdCaracteristica}>
          {this.returnCaracteristicaPai(caracteristicaPai, indexPai)}
        </Panel>
      );
  }

  /*
    Funcao com estilização do sistema externo
  */
  returnCaracteristicaPaiExterno(caracteristicaPai, indexPai) {
    return (
      <div
        key={caracteristicaPai.IdCaracteristica}
        className={'mt-4'}
        style={{ borderLeft: '5px solid #E0E0E0', paddingLeft: 12 }}
      >
        <h4 className={'mb-3'}>{caracteristicaPai.Descricao}</h4>
        {this.returnCaracteristicaPai(caracteristicaPai, indexPai)}
      </div>
    );
  }

  /*
    Funcao genérica que retorna um DDadosItem
  */
  returnCaracteristicaFilha(caracteristicaFilha, indexFilha, indexPai) {
    const { isView, desabilitaCamposObrigatorios, disableAll } = this.props;

    const obrigatorio = !!parseInt(caracteristicaFilha.Obrigatorio) && !isView && !desabilitaCamposObrigatorios;

    return (
      <DDadosItem
        validateOnBlur={caracteristicaFilha.TipoCaracteristica === EnumTipoCaracteristica.Data}
        name={caracteristicaFilha.Descricao}
        Placeholder={caracteristicaFilha.Descricao}
        Label={caracteristicaFilha.Descricao}
        Obrigatorio={obrigatorio}
        Tipo={caracteristicaFilha.TipoCampo}
        state={caracteristicaFilha.Valor}
        stateName={'Exibicao'}
        onChange={(valor) => this.onChangeCaracteristica(indexPai, indexFilha, valor)}
        Tooltip={caracteristicaFilha.Tooltip}
        Tamanho={caracteristicaFilha.TamanhoMaximo}
        CasasDecimais={caracteristicaFilha.Precisao}
        itens={caracteristicaFilha.CaracteristicasValores}
        isView={isView || disableAll}
      />
    );
  }

  /*
    Funcao que abstrai o render do componente interno
  */
  renderComponentInterno() {
    const { state: arrayCaracteristicas } = this.props;
    return (
      arrayCaracteristicas &&
      arrayCaracteristicas.map((caracteristicaPai, indexPai) =>
        this.returnCaracteristicaPaiInterno(caracteristicaPai, indexPai)
      )
    );
  }

  /*
    Funcao que abstrai o render do componente externo
  */
  renderComponentExterno() {
    const { state: arrayCaracteristicas } = this.props;
    return (
      arrayCaracteristicas &&
      arrayCaracteristicas.map((caracteristicaPai, indexPai) =>
        this.returnCaracteristicaPaiExterno(caracteristicaPai, indexPai)
      )
    );
  }

  render() {
    const { isExterno } = this.props;

    return (
      <Fragment>
        {!isExterno && this.renderComponentInterno()}
        {isExterno && this.renderComponentExterno()}
      </Fragment>
    );
  }
}
